"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sub = void 0;
var _react = _interopRequireDefault(require("react"));
var _Sub = require("b2b-components/core/components/Footer/Footer/Sub");
require("./Sub.scss");
// export * from 'b2b-components/core/components/Footer/Footer/Sub/Sub';

const Sub = props => {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Sub.Sub, props));
};
exports.Sub = Sub;
//# sourceMappingURL=Sub.js.map